import React, { useEffect, useRef, useState } from "react";
import {
  createFollowUpCommiteAction,
  updateFollowUpCommiteAction,
} from "../../../Actions/FollowUpCommiteAction/FollowUpCommiteAction";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { MdOutlineAssignmentReturned, MdOutlineSaveAlt } from "react-icons/md";
import Select from "react-select";
import { getDcotorAction } from "../../../Actions/DoctorAction/DoctorAction";
import {
  getSurgeryAction,
  showOrganAction,
  showTypeSurgeryAction,
} from "../../../Actions/SurgeryAction/SurgeryAction";
import { getTypeOfHeAction } from "../../../Actions/SurgeryAction/TypeOfHelpAction";
import { updateAssignPatientInfoAction } from "../../../Actions/PatientActions/PatientAction";
import { IoMdPrint } from "react-icons/io";
import ReactToPrint from "react-to-print";
import PrintPage from "../../PrintPage/PrintPage";

const VisitiProfile = ({ visit, followUp, setActiveTab, forms }) => {
  const { id: patient_id } = useParams();

  const [inputValue, setInputValue] = useState({});
  const dispatch = useDispatch();
  const [surgeryId, setSurgeryId] = useState([]);
  const [typeSurgeryId, setTypeSurgeryId] = useState([]);

  const [TYPId, setTYPId] = useState([]);
  const [organLevelId, setOrganLevelId] = useState([]);
  const [doctorId, setDoctorId] = useState([]);

  const getTypeOfHelp = useSelector((state) => state.getTypeOfHelp);
  const { typeOfHelps } = getTypeOfHelp;
  const [typeOfHelp, setTypeOfHelp] = useState([]);
  let typeOfHelpList = [];
  typeOfHelps?.map((type) => {
    typeOfHelpList.push({
      label: type.name,
      value: type.name,
    });
  });
  useEffect(() => {
    dispatch(getSurgeryAction());
    dispatch(getDcotorAction(1));
    dispatch(getTypeOfHeAction());
  }, []);
  const getDoctor = useSelector((state) => state.getDoctor);
  const { doctors } = getDoctor;
  const getSurgery = useSelector((state) => state.getSurgery);
  const { surgeries } = getSurgery;
  const showOrgan = useSelector((state) => state.showOrgan);
  const { organs } = showOrgan;
  const showTypeSurgery = useSelector((state) => state.showTypeSurgery);
  const { typeSurgeries } = showTypeSurgery;
  let typeSurgeryList = [];
  let typeSurgeryKRDList = [];
  let organLevelList = [];
  // organ
  typeSurgeries?.map((type) => {
    typeSurgeryList.push({
      label: type.name,
      value: type.id,
    });
  });
  organs?.map((organ) => {
    organLevelList.push({
      label: organ.en_name,
      value: organ.id,
    });

    typeSurgeryKRDList.push({
      label: organ.ku_name,
      value: organ.id,
    });
  });

  useEffect(() => {
    if (surgeryId == null || surgeryId.length <= 0 || surgeryId == undefined) {
      return;
    } else {
      dispatch(showTypeSurgeryAction(surgeryId));
    }
  }, [surgeryId]);

  useEffect(() => {
    if (
      typeSurgeryId == null ||
      typeSurgeryId.length <= 0 ||
      typeSurgeryId == undefined
    ) {
      return;
    } else {
      dispatch(showOrganAction(typeSurgeryId));
    }
  }, [typeSurgeryId]);
  let surgeryList = [];
  surgeries?.map((surgery) => {
    surgeryList?.push({
      label: surgery.name,
      value: surgery.id,
    });
  });
  const handleChangeOptions = (selectedOptis, type) => {
    console.log(selectedOptis);
    if (type == "surgery") {
      setSurgeryId(selectedOptis);
    }
    if (type == "typeSurgery") {
      setTypeSurgeryId(selectedOptis);
    }
    if (type == "TYP") {
      // console.log(selectedOptis)
      setTYPId(selectedOptis);
    }
    if (type == "organLevel") {
      const tempTyp = [];
      const tempId = [];
      selectedOptis.map((item) => {
        tempId.push(item.value);
      });

      organs.map((organ) => {
        if (tempId.includes(organ.id)) {
          tempTyp.push({
            label: organ.ku_name,
            value: organ.id,
          });
        }
      });
      setTYPId(tempTyp);
      setOrganLevelId(selectedOptis);
    }

    if (type == "doctor") {
      setDoctorId(selectedOptis);
    }
    if (type == "typeOfHelp") {
      setTypeOfHelp(selectedOptis);
    }
  };

  let doctorList = [];
  doctors?.map((doctor) => {
    doctorList.push({
      label: doctor.name,
      value: doctor.id,
    });
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };
  const handleSubmit = (e, assign) => {
    e.preventDefault();
    let notes = [];
    let types = [];
    const ids = [];

    followUp?.map((follow) => {
      ids.push(follow.id);
    });
    dispatch(
      updateAssignPatientInfoAction(visit.patient.patient_info.id, assign)
    );
    Object.entries(inputValue).map(([key, value]) => {
      notes.push(value);
      types.push(key);
    });

    if (followUp.length > 0) {
      dispatch(
        updateFollowUpCommiteAction(
          ids,
          patient_id,
          visit?.id,
          types,
          notes,
          doctorId,
          surgeryId,
          typeSurgeryId,
          organLevelId,
          TYPId,
          typeOfHelp,
          assign
        )
      );
      handleClear();
      handleClear();
    } else {
      dispatch(
        createFollowUpCommiteAction(
          visit?.id,
          patient_id,
          types,
          notes,
          doctorId,
          surgeryId,
          typeSurgeryId,
          organLevelId,
          TYPId,
          typeOfHelp,
          assign
        )
      );
      handleClear();
    }
  };
  const handleClear = () => {
    setSurgeryId([]);
    setTypeSurgeryId([]);
    setTYPId([]);
    setOrganLevelId([]);
    setDoctorId([]);
    setTypeOfHelp([]);
    setInputValue({});
  };
  useEffect(() => {
    let tempInputValue = {};

    if (followUp?.length > 0) {
      setTypeOfHelp([]);
      setDoctorId([]);
      setTYPId([]);
      setSurgeryId([]);
      setTypeSurgeryId([]);
      setOrganLevelId([]);
      const updatedTypeOfHelp = followUp[0]?.type_of_help.map((type) => ({
        label: type,
        value: type,
      }));
      setTypeOfHelp(updatedTypeOfHelp);

      if (followUp[0]?.doctor) {
        const updatedDoctorId = followUp[0].doctor.map((doctor) => ({
          label: doctor,
          value: doctor,
        }));
        setDoctorId(updatedDoctorId);
      }

      if (followUp[0]?.TYP) {
        const updatedTYPId = followUp[0].TYP.map((TYP) => ({
          label: TYP,
          value: TYP,
        }));
        setTYPId(updatedTYPId);
      }

      if (followUp[0]?.disease_type_specialist) {
        const updatedSurgeryId = followUp[0].disease_type_specialist.map(
          (diseaseType) => ({
            label: diseaseType,
            value: diseaseType,
          })
        );
        setSurgeryId(updatedSurgeryId);
      }

      if (followUp[0]?.organ) {
        const updatedTypeSurgeryId = followUp[0].organ.map((organ) => ({
          label: organ,
          value: organ,
        }));
        setTypeSurgeryId(updatedTypeSurgeryId);
      }

      if (followUp[0]?.organ_level) {
        const updatedOrganLevelId = followUp[0].organ_level.map((organ) => ({
          label: organ,
          value: organ,
        }));
        setOrganLevelId(updatedOrganLevelId);
      }

      followUp.map((follow) => {
        tempInputValue[follow.type] = follow.note;
      });
    } else {
      forms.forEach((form) => {
        form.sectionForm.forEach((section) => {
          section.field.forEach((field) => {
            tempInputValue[field.name] = "";
          });
        });
      });
    }
    setInputValue(tempInputValue);
  }, [visit]);
  const printRef = useRef();
  return (
    <div className="mt-3 pb-2">
      <div className="w-full  flex flex-col">
        <div>
          <label htmlFor="">Type Of Help *</label>
        </div>
        <Select
          options={typeOfHelpList}
          value={typeOfHelp}
          onChange={(selected) => handleChangeOptions(selected, "typeOfHelp")}
          isMulti
        />
      </div>
      {typeOfHelp.length > 0 ? (
        <>
          <form action="">
            {forms?.map((form, formIndex) => {
              return form.sectionForm.map((section, sectionIndex) => {
                return (
                  <div className=" ">
                    <div
                      className="bg-teal-500 p-1.5 lg:w-3/12 my-2 m-auto rounded-sm text-white text-center shadow-md"
                      key={sectionIndex}
                    >
                      {section.title}
                    </div>
                    <div className="flex flex-row-reverse justify-center w-full items-center flex-wrap gap-3 my-2">
                      {section.field.map((field, index) => (
                        <div
                          className="flex flex-col text-right basis-1/5"
                          key={index}
                        >
                          <div>
                            {
                            field.type=="textarea"?"": <label htmlFor="" className="text-sm">* {field.label} </label>
                            }
                           
                          </div>
                          {field.type === "textarea" ? (
                            ""
                          ) : field.type === "dropdown" ? (
                            <select
                              className="p-1.5 border mt-1"
                              type={field.type}
                              name={field.name}
                              placeholder={field.placeholder}
                              onChange={handleInputChange}
                              value={inputValue[field.name]}
                              id=""
                            >
                              <option value="">
                                تکایە زانیاریەکە هەڵبژێرە
                              </option>
                              {field?.drop_down.map((dropdown, index) => (
                                <option value={dropdown.value} key={index}>
                                  {dropdown.value}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type={field.type}
                              name={field.name}
                              placeholder={field.placeholder}
                              onChange={handleInputChange}
                              value={inputValue[field.name]}
                              className="p-1.5 mt-1 text-right"
                            />
                          )}
                        </div>
                      ))}
                    </div>

                    <hr />
                  </div>
                );
              });
            })}
            <div className="grid grid-cols-2 md:grid-cols-3 mt-8 lg:grid-cols-4 gap-2">
              {typeOfHelp.some(
                (item) => item.label === "پێداویستی پزیشکی"
              ) ? null : (
                <>
                  <div className="w-full flex flex-col">
                    <div>
                      <label htmlFor="">Doctor *</label>
                    </div>
                    <Select
                      options={doctorList}
                      value={doctorId}
                      onChange={(selected) =>
                        handleChangeOptions(selected, "doctor")
                      }
                      isMulti
                    />
                  </div>
                  <div className="w-full flex flex-col">
                    <div className="">
                      <label htmlFor=""> Disease type specialist *</label>
                    </div>
                    <Select
                      options={surgeryList}
                      isMulti
                      value={surgeryId}
                      onChange={(selected) =>
                        handleChangeOptions(selected, "surgery")
                      }
                    />
                  </div>

                  <div className="w-full flex flex-col">
                    <div>Organ *</div>
                    <Select
                      options={typeSurgeryList}
                      isMulti
                      value={typeSurgeryId}
                      onChange={(selected) =>
                        handleChangeOptions(selected, "typeSurgery")
                      }
                    />
                  </div>
                  <div className="w-full flex flex-col">
                    <div>Organ Level *</div>
                    <Select
                      options={organLevelList}
                      isMulti
                      value={organLevelId}
                      onChange={(selected) =>
                        handleChangeOptions(selected, "organLevel")
                      }
                    />
                  </div>
                  <div className="w-full flex flex-col">
                    <div>TYP *</div>
                    <Select
                    isDisabled
                      options={typeSurgeryKRDList}
                      isMulti
                      value={TYPId}
                      onChange={(selected) =>
                        handleChangeOptions(selected, "TYP")
                      }
                    />
                  </div>
                </>
              )}
            </div>

            {forms?.map((form, formIndex) => {
              return form.sectionForm.map((section, sectionIndex) => {
                return (
                  <div key={sectionIndex + formIndex}>
                    <div className="grid grid-cols-1 gap-2">
                      {section.field.map((field, index) => {
                        return (
                          <>
                            {field.type == "textarea" ? (
                              <div className="flex flex-col">
                                <label htmlFor="">{field.label + " *"}</label>
                                <div>
                                  <textarea
                                    key={index}
                                    type={field.type}
                                    name={field.name}
                                    placeholder={field.placeholder}
                                    onChange={handleInputChange}
                                    value={inputValue[field.name]}
                                    className="input w-full"
                                    id=""
                                  ></textarea>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                );
              });
            })}
          </form>

          {visit?.assign == 2 ? (
            ""
          ) : (
            <div className="flex mt-3 gap-2 justify-end w-full mr-2">
              <button className="btn-blue" onClick={(e) => handleSubmit(e, 1)}>
                Save <MdOutlineSaveAlt />
              </button>

              <button className="btn-teal" onClick={(e) => handleSubmit(e, 2)}>
                Assign <MdOutlineAssignmentReturned />
              </button>

              <div>
                <ReactToPrint
                  trigger={() => (
                    <button className="btn-red">
                      Print <IoMdPrint />
                    </button>
                  )}
                  content={() => printRef.current}
                />
                <div hidden>
                  <PrintPage
                    ref={printRef}
                    followUp={followUp}
                    visit={visit}
                    forms={forms}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default VisitiProfile;
